import { ReactNode } from "react";
import styled from "styled-components";

export default function Error({ errorMessage }: { errorMessage: string | ReactNode }) {
	return <ErrorWrapper>{errorMessage || "En feil skjedde"}</ErrorWrapper>;
}

const ErrorWrapper = styled.div`
	padding: 12px 24px;
	box-sizing: border-box;
	background-color: var(--varsel-roed-10);
	color: #000000;
	font-weight: 500;
`;
